import React from "react";

export default function ElementsPanel() {
return (
  <div
    className="
      p-4 flex flex-col gap-4
      text-gray-900 dark:text-gray-100
    "
  >
    {/* Title */}
    <h3 className="text-lg font-semibold">Elements</h3>

    {/* Description */}
    <div className="text-sm text-gray-600 dark:text-gray-400">
      Stickers, shapes, icons
    </div>

    {/* Elements grid */}
    <div className="grid grid-cols-3 gap-2">
      {["★", "◼", "♡"].map((el, i) => (
        <button
          key={i}
          className="
            h-12 rounded-lg
            flex items-center justify-center
            text-lg
            bg-gray-100 hover:bg-gray-200
            dark:bg-gray-800 dark:hover:bg-gray-700
            border border-gray-200 dark:border-gray-700
            transition-colors
          "
        >
          {el}
        </button>
      ))}
    </div>

    {/* Insert button */}
    <button
      className="
        mt-2 w-full py-2 rounded-lg
        bg-blue-600 hover:bg-blue-700
        text-white
        transition-colors
      "
    >
      Insert
    </button>
  </div>
);

}